/// FOURJS_START_COPYRIGHT(D,2025)
/// Property of Four Js*
/// (c) Copyright Four Js 2025, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

/**
 *
 * @namespace classes.ObjectHelper
 */
const ObjectHelper = /** @lends classes.ObjectHelper*/ {
  isString: function (obj) {
    return typeof obj === "string";
  },
  isNumber: function (obj) {
    return typeof obj === "number";
  },
  isFunction: function (obj) {
    return typeof obj === "function";
  },
  isBoolean: function (obj) {
    return obj === true || obj === false;
  }
};

modulum("ObjectHelper", function (context, cls) {
  cls.ObjectHelper = ObjectHelper;
});

if (typeof module !== "undefined" && module.exports) {
  module.exports = ObjectHelper;
}
